var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomesticG(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4H36V36H4V4ZM2 4C2 2.89543 2.89543 2 4 2H36C37.1046 2 38 2.89543 38 4V36C38 37.1046 37.1046 38 36 38H4C2.89543 38 2 37.1046 2 36V4ZM19 10H21V16H19V10ZM17 8H19H21H23V10V16V18H21H19H17V16V10V8ZM30 28V27H24V28H30ZM32 27V25H30H24H22V27V28V30H24H30H32V28V27ZM16 27V28H10V27H16ZM18 25V27V28V30H16H10H8V28V27V25H10H16H18Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomesticG);
export default __webpack_public_path__ + "static/media/DOMESTIC_G.9920146d3f95dc3614baf6870a74e7f8.svg";
export { ForwardRef as ReactComponent };